// @mui
import { useTheme } from "@mui/material/styles";
// config

import { MapWithSignlePin } from "../../MapWithSignlePin/MapWithSignlePin";
import { Box } from "@mui/material";

// ----------------------------------------------------------------------
type Office = "base" | "seabreeze" | "sbtours" | "default";

interface Props {
  officeType?: Office;
}

const BASE_OFFICE = {
  latitude: 49.82954434049678,
  longitude: 40.369030580986085,
};

const SEA_BREEZE_OFFICE = {
  latitude: 49.988830277206716,
  longitude: 40.57627542797198,
};

const SBTOURS_OFFICE = {
  latitude: 37.390514,
  longitude: 55.803479,
};

const DEFAULT_OFFICE = {
  latitude: 49.89201,
  longitude: 40.37767,
};

const getCoords = (officeType: Office) => {
  switch (officeType) {
    case "base":
      return BASE_OFFICE;
    case "seabreeze":
      return SEA_BREEZE_OFFICE;
    case "sbtours":
      return SBTOURS_OFFICE;
    default:
      return DEFAULT_OFFICE;
  }
};

// ----------------------------------------------------------------------

export default function ContactMap({ officeType = "default" }: Props) {
  const theme = useTheme();
  const { longitude, latitude } = getCoords(officeType);
  return (
    <Box
      sx={{
        zIndex: 0,
        overflow: "hidden",
        position: "relative",
        borderRadius: theme.shape.borderRadius / 16,
        "& .mapboxgl-ctrl-logo, .mapboxgl-ctrl-bottom-right": {
          display: "none",
        },
      }}
    >
      <MapWithSignlePin zoom={12} coordinates={[latitude, longitude]} />
    </Box>
  );
}
